export default {
  config: {
    step: 0,
    estado: '',
    cargaPersonasToggle: false,
    cargarContraventorToggle: false,
    verPedidoEnvio: false,
    verDepositoContravencion: false,
  },
  autorizacionViaje: {
    cantidad_dias: 0,
    numero_acta_nacimiento: '',
    destinos: '',
  },
  personas: [],
  expediente: {
    _id: '',
    codigoOrganismo: '',
    tipo: {},
    numero: 0,
    anio: '',
    fechaHecho: '',
    fechaPrescripcion: '',
    fechaIngreso: '',
    caratula: '',
    actuaciones: [],
    contraventores: [],
    organismo: {},
  },
  busquedaExpedientes: {
    tipo_doc: null,
    num_doc: null,
    nombre: null,
    apellido: null,
    pagina: 1,
    cantidadTotal: 0,
    cantidadPorPagina: 10,
  },
  contraventores: [],
  detalles: [],
  pedido: {
    _id: '',
    numero: '',
    detalle: [],
    importe: 0,
    estado: '',
    organismo: {},
    observacion: '',
    usuarioCreador: {},
    fechaPedido: '',
  },
  keycloak: {
    isLoggedIn: false,
    isLoggingIn: false,
    user: null,
    error: null,
    isPublicRoute: false,
  },
};
